/**
 * Debug Resolution Display
 *
 * Shows current screen resolution in the bottom-left corner.
 * For debugging purposes only.
 */

let resolutionElement: HTMLDivElement | null = null;

/**
 * Create and show the resolution display.
 */
export function showResolutionDisplay(): void {
  if (resolutionElement) return;

  console.log('[ResolutionDisplay] Creating resolution display');
  resolutionElement = document.createElement('div');
  resolutionElement.id = 'resolution-display';
  resolutionElement.style.cssText = `
    position: fixed;
    bottom: 10px;
    left: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    z-index: 999998;
    pointer-events: none;
  `;

  updateResolution();
  document.body.appendChild(resolutionElement);

  window.addEventListener('resize', updateResolution);
}

/**
 * Update the displayed resolution.
 */
function updateResolution(): void {
  if (!resolutionElement) return;
  const width = window.innerWidth;
  const height = window.innerHeight;
  resolutionElement.textContent = `${width} × ${height}`;
}

/**
 * Hide and remove the resolution display.
 */
export function hideResolutionDisplay(): void {
  if (resolutionElement) {
    window.removeEventListener('resize', updateResolution);
    resolutionElement.remove();
    resolutionElement = null;
  }
}
